import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAircallComponent } from './simple-icons-aircall.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAircallComponent ],
    exports:      [ SimpleIconsAircallComponent ],
    bootstrap:    []
})
export class SimpleIconsAircallModule {}
